module.exports = __webpack_public_path__ + "static/media/pdfDoc.b0dd778f.svg";